export default {
	COLLECTION_ID: 'HEADER_BAR_COLLECTION',
	// Fetching statuses
	PRODUCTS_NOT_LOADED: 'PRODUCTS_NOT_LOADED',
	FETCHING_PRODUCTS: 'FETCHING_PRODUCTS',
	FETCH_PRODUCTS_ERROR: 'FETCH_PRODUCTS_ERROR',
	FETCH_PRODUCTS_SUCCESS: 'FETCH_PRODUCTS_SUCCESS',
	// Actions
	HEADER_BAR_FETCH_PRODUCTS: 'HEADER_BAR_FETCH_PRODUCTS',
	HEADER_BAR_OPEN_PRODUCT: 'HEADER_BAR_OPEN_PRODUCT',
};
